"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaydiumLPStakeAction = void 0;
const sdk_1 = require("@malloc-protocol/sdk");
const web3_js_1 = require("@solana/web3.js");
const cpi_action_json_1 = __importDefault(require("../../target/idl/cpi_action.json"));
const { getTokenAccountUsedByMalloc } = sdk_1.utils.tokens;
const cpi_action_1 = require("../utils/cpi-action");
const raydium_sdk_1 = require("@raydium-io/raydium-sdk");
const bn_js_1 = __importDefault(require("bn.js"));
const raydium_utils_1 = require("./raydium-utils");
const actionTypeUID = "MALLOC_SPL_RAYDIUM_LP_STAKE_FARM";
const buildIsolatedRaydiumLpStake = ({ inp, inputTokens: inpTokAccounts, actionPID, provider, authority, opts, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    if (inpTokAccounts.length !== 1)
        throw `Farming expects 1 input tokens (the LP token)`;
    const farmPoolKeys = (_a = inp.farmPoolKeys) !== null && _a !== void 0 ? _a : (yield (0, raydium_utils_1.getMainnetRaydiumFarms)({ lpMint: inpTokAccounts[0].mint }))[0]; // TODO: this is just getting the first farm pool
    const dummy1Amount = new bn_js_1.default(0);
    const lpMint = inpTokAccounts[0].mint;
    if (!lpMint.equals(farmPoolKeys.lpMint))
        throw `Expected the input token mint to equal the farming pool's token mint`;
    const rewardTokenAccounts = (_c = (_b = inp.rewardTokenAccounts) === null || _b === void 0 ? void 0 : _b.map((t) => new web3_js_1.PublicKey(t))) !== null && _c !== void 0 ? _c : (yield Promise.all(farmPoolKeys.rewardMints.map((m) => getTokenAccountUsedByMalloc(authority, m, opts.preferredTokenAccounts))));
    let ledger;
    let ledgerInsts;
    let additionalSigners = [];
    // TODO: seperate functions or at least comment
    // if (farmPoolKeys.version === 5) {
    if (farmPoolKeys.version === 5 || farmPoolKeys.version === 3) {
        ledger = yield raydium_sdk_1.Farm.getAssociatedLedger({
            programId: farmPoolKeys.programId,
            poolId: farmPoolKeys.id,
            owner: authority,
        });
        const farmInfos = yield raydium_sdk_1.Farm.getMultipleInfo({
            connection: provider.connection,
            pools: [farmPoolKeys],
            config: {
                batchRequest: true,
            },
        });
        const { ledger: foundLedger } = farmInfos[farmPoolKeys.id.toBase58()];
        if (!foundLedger) {
            const instMakeAccount = yield raydium_sdk_1.Farm.makeCreateAssociatedLedgerAccountInstruction({
                poolKeys: farmPoolKeys,
                userKeys: { owner: authority, ledger },
            });
            ledgerInsts = [instMakeAccount];
        }
    }
    // } else if (farmPoolKeys.version === 3) {
    //   const stakeFilters = [
    //     {
    //       memcmp: {
    //         offset: 40,
    //         bytes: provider.wallet.publicKey.toBase58(),
    //       },
    //     },
    //     {
    //       dataSize: FARM_VERSION_TO_LEDGER_LAYOUT[3].span,
    //     },
    //   ];
    //   ledger = await getStakeInfoV3Accounts(
    //     provider.connection,
    //     stakeFilters,
    //     farmPoolKeys.programId,
    //     farmPoolKeys
    //   );
    //   if (!ledger) {
    //     const layout = FARM_VERSION_TO_LEDGER_LAYOUT[farmPoolKeys.version];
    //     const ledgerAccount = new Account();
    //     ledger = ledgerAccount.publicKey;
    //     const ledgerInstAdd =
    //       await Farm.makeCreateAssociatedLedgerAccountInstruction({
    //         poolKeys: farmPoolKeys,
    //         userKeys: {
    //           owner: authority,
    //           ledger,
    //         },
    //       });
    // SystemProgram.createAccount({
    //   fromPubkey: authority,
    //   programId: farmPoolKeys.programId,
    //   newAccountPubkey: ledgerAccount.publicKey, // TODO: what
    //   space: layout.span,
    //   lamports: await provider.connection.getMinimumBalanceForRentExemption(
    //     layout.span
    //   ),
    // });
    //   ledgerInsts = [ledgerInstAdd];
    //   additionalSigners.push(ledgerAccount);
    // }
    else {
        throw `Expected the farm pool to be version 3 or 5`;
    }
    const params = {
        poolKeys: farmPoolKeys,
        userKeys: {
            ledger: ledger,
            lpTokenAccount: inpTokAccounts[0].tokenAccount,
            rewardTokenAccounts,
            owner: authority,
        },
        amount: dummy1Amount,
    };
    // Get the instruction for the mint
    const inst = raydium_sdk_1.Farm.makeDepositInstruction(params);
    const data = (0, cpi_action_1.packInstrData)(inst.data, cpi_action_1.InstructionType.RAYDIUM_POOL_LIQUIDITY_STAKE);
    return {
        estimateOuts: (amounts) => {
            return [];
        },
        isolatedAction: {
            actionTypeUID,
            tokenMintIn: inpTokAccounts.map((m) => m.mint),
            actionData: data,
            actionProgram: new web3_js_1.PublicKey(actionPID),
            actionAccounts: [
                { address: inst.programId },
                ...sdk_1.utils.object.actionMetasToAccountsArray(inst.keys),
            ],
            additionalSigners: [],
            tokenMintOuts: [],
            tokenAccountOuts: [],
            opts: {
                additionalSigners: additionalSigners.length > 0 ? additionalSigners : undefined,
                instructions: ledgerInsts ? ledgerInsts : undefined,
                tokenCreationOptions: {
                    extraTokenMintsUsed: farmPoolKeys.rewardMints,
                },
            },
        },
    };
});
exports.RaydiumLPStakeAction = {
    buildIsolatedAction: buildIsolatedRaydiumLpStake,
    actionTypeUID,
    idl: cpi_action_json_1.default,
    expectedNumberOutMints: 0,
};
const getStakeInfoV3Accounts = (conn, stakeFilters, stakePID, farm) => __awaiter(void 0, void 0, void 0, function* () {
    var _d;
    const stakeAccounts = {};
    const stakeAccountInfos = yield getFilteredProgramAccounts(conn, stakePID, stakeFilters);
    return (_d = stakeAccountInfos.find((stakeAccountInfo) => {
        const stakeAccountAddress = stakeAccountInfo.publicKey.toBase58();
        const { data } = stakeAccountInfo.accountInfo;
        const userStakeInfo = raydium_sdk_1.FARM_VERSION_TO_LEDGER_LAYOUT[3].decode(data);
        const poolId = userStakeInfo.id.toBase58();
        return poolId === farm.id.toBase58();
    })) === null || _d === void 0 ? void 0 : _d.publicKey;
});
function getFilteredProgramAccounts(connection, programId, filters) {
    return __awaiter(this, void 0, void 0, function* () {
        // @ts-ignore
        const resp = yield connection._rpcRequest("getProgramAccounts", [
            programId.toBase58(),
            {
                commitment: connection.commitment,
                filters,
                encoding: "base64",
            },
        ]);
        if (resp.error) {
            throw new Error(resp.error.message);
        }
        // @ts-ignore
        return resp.result.map(({ pubkey, account: { data, executable, owner, lamports } }) => ({
            publicKey: new web3_js_1.PublicKey(pubkey),
            accountInfo: {
                data: Buffer.from(data[0], "base64"),
                executable,
                owner: new web3_js_1.PublicKey(owner),
                lamports,
            },
        }));
    });
}
